// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"7":"b3a67ac0","224":"f0e3c6b7","640":"2dc12e0b","655":"252e3c00","874":"aa8e1a93","927":"65372715"}[chunkId] + ".js";
};